<template>
    <v-card style="min-width: 100%; padding: 1rem" v-if="rol == 1 || rol == 2 || rol == 9">
        <v-row>

            <v-col cols="12">
                <multiple-select :readonly="readonly" :headers="headers_metodos" title="Formas de pago" :elementos="metodos_pago
                    " @create="createAgente" @delete="deleteAgentes" @getEstado="updateAgentesS"
                    @update="updateAgentes">
                    <v-row>
                        <v-col cols="12">
                            <v-autocomplete v-model="metodo.id_metodo
                                " :items="metodos" item-text="nombre" item-value="id" label="Método">
                            </v-autocomplete>
                        </v-col>
                        <v-col cols="12">
                            <div style="display:flex">
                                <v-text-field type="number" v-model="metodo.monto
                                    " label="Porcentaje">
                                </v-text-field>
                                <v-btn-toggle color="primary" shaped v-model="metodo.id_tipo_dcto"
                                    background-color="white">
                                    <v-btn text>
                                        <v-icon>mdi-percent</v-icon>
                                    </v-btn>
                                    <v-btn text>
                                        <v-icon>mdi-currency-eur</v-icon>
                                    </v-btn>
                                </v-btn-toggle>
                            </div>
                        </v-col>
                    </v-row>
                </multiple-select>
            </v-col>
        </v-row>
        <v-card>
            <v-row>
                <v-col cols="4">
                    <h4>Total:</h4>
                </v-col>
                <v-col cols="4">
                    <h4 class="text-center" :style="totalPorcentaje != 100
                        ? 'color:red'
                        : ''
                        ">
                        {{
                            formatNumber(
                                totalPorcentaje
                            )
                        }}
                        %
                    </h4>
                </v-col>
                <v-col cols="4">
                    <h4 class="text-center">{{ totalMetodoPago |format_precio }}</h4>
                </v-col>
            </v-row>
        </v-card>
    </v-card>
</template>
<script>
export default {
    props: ['value', 'readonly', 'orden', 'facturas'],
    data() {
        return {
            metodo: {
                id_tipo_dcto: 0,
            },
            total: 0,
            metodos_pago: []
        }
    },
    created() {

    },
    methods: {
        formatNumber(number) {
            return Number.parseFloat((number ?? 0).toString())
                .toFixed(2)
                .replace(".", ",")
                .replace(",00", "");
        },
        create() {
            if (this.metodos_pago == null) {
                this.metodos_pago = [];
            } else {
                this.updateMetodos();
            }
        },
        updateMetodos() {

            if (this.orden != null) {
                this.metodos_pago.forEach((element) => {
                    if (element.id_tipo_dcto == 1) {
                        element.total = element.monto;
                        element.porcentaje = parseFloat((element.monto / this.orden.importe * 100).toFixed(2))

                    } else {
                        element.total =
                            (parseFloat(this.orden.importe) *
                                parseFloat(element.monto)) /
                            100;
                        element.porcentaje = element.monto;
                    }
                });
                this.total = 1;
                this.total = 0;
            }
        },
        updateAgentesS(index) {
            //console.log(index);
            this.metodo = JSON.parse(
                JSON.stringify(this.metodos_pago[index])
            );
            this.index = index;
        },
        //metodos
        deleteAgentes(indexo) {
            this.metodos_pago.splice(indexo, 1);
        },
        createAgente() {
            //console.log(this.metodo.id_metodo);
            this.metodos_pago.push({
                id: null,
                id_metodo: this.metodo.id_metodo,
                monto: this.metodo.monto,
                id_tipo_dcto: this.metodo.id_tipo_dcto,
                metodo: JSON.parse(
                    JSON.stringify(
                        this.metodos.find(
                            (element) => element.id == this.metodo.id_metodo
                        )
                    )
                ),
            });
            this.metodo = {
                id_tipo_dcto: 0,
            };
        },

        updateAgentes() {
            this.metodos_pago[this.index].id_metodo =
                this.metodo.id_metodo;
            this.metodos_pago[this.index].monto = this.metodo.monto;
            this.metodos_pago[this.index].id_tipo_dcto = this.metodo.id_tipo_dcto;
            (this.metodos_pago[this.index].metodo = JSON.parse(
                JSON.stringify(
                    this.metodos.find(
                        (element) => element.id == this.metodo.id_metodo
                    )
                )
            )),
                (this.metodo = { id_tipo_dcto: 0, });
            this.updateMetodos();
        },


    },
    watch: {
        metodos_pago(val) {
            this.$emit("input", val ?? []);
        },
        value: {
            deep: true,
            handler(val) {

                this.metodos_pago = val ?? [];
                this.create();
            },
        },


        "orden.importe"(val) {
            this.updateMetodos();
        },

        "facturas"(val) {
            //this.saveFacturas();
        }
    },
    computed: {
        // Total en procentaje
        totalPorcentaje() {
            let total = this.total;
            this.metodos_pago.forEach((element) => {
                let per = parseFloat(element.porcentaje);
                total += per;
            });
            return total;
        },
        // Valor del total
        totalMetodoPago() {
            let total = this.total;
            this.metodos_pago.forEach((element) => {
                let valor = parseFloat(element.total);
                total += valor;
            });
            return total;
        },
        headers_metodos() {
            let headers_metodos = [
                { text: "Método", value: "metodo.nombre", sortable: false },
                { text: "Porcentaje (%)", value: "porcentaje", sortable: false },
                { text: "Total", value: "total", sortable: false },
                ...(!this.readonly
                    ? [{ text: "Acciones", value: "action", sortable: false }]
                    : []),
            ];

            return headers_metodos;
        },
        rol() {
            return parseInt(localStorage.getItem("role"));
        },
        metodos() {
            return this.$store.getters.metodos_pago.filter(
                (ele) => ele.id_tipo == 1
            );
        },
    }
}
</script>